import React, { PropsWithChildren } from "react";
//#region types
import { ExtendedEntityPaginationProps } from "models/propTypes/navigationPropTypes";
import { StyleEnums } from "models/enums";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { Grid, Typography } from "@mui/material";
import { WChevronLeft, WChevronRight } from "utils/constants/iconDefinitions";
import StyledButton from "../buttons/styledButton";
import Icon from "../icon";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance } from "utils/helpers";

const ExtendedEntityPagination: React.FC<PropsWithChildren<ExtendedEntityPaginationProps>> = (props) => {
  const { textNext, textPrevious } = props;
  const itemNext = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.stopPropagation();
    props.onNavigationNext && props.onNavigationNext();
  };

  const itemPrev = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.stopPropagation();
    props.onNavigationPrevious && props.onNavigationPrevious();
  };

  return (
    <Grid
      container
      justifyContent={"space-between"}
      alignItems={"flex-end"}
      className={cssExports.extendedEntityPaginationContainer}
    >
      <Grid item>
        <StyledButton displayType={StyleEnums.DisplayType.None} onClick={itemPrev}>
          <Grid container alignItems={"center"}>
            <Icon icon={WChevronLeft} />
            <Typography>
              {LocalizationHelperInstance.getFormattedMessage(textPrevious ?? TranslationKeys.Common.Previous)}
            </Typography>
          </Grid>
        </StyledButton>
      </Grid>
      <Grid item className={cssExports.titleContainer}>
        {props.children}
      </Grid>
      <Grid item>
        <StyledButton displayType={StyleEnums.DisplayType.None} onClick={itemNext}>
          <Grid container alignItems={"center"}>
            <Typography>
              {LocalizationHelperInstance.getFormattedMessage(textNext ?? TranslationKeys.Common.Next)}
            </Typography>
            <Icon icon={WChevronRight} />
          </Grid>
        </StyledButton>
      </Grid>
    </Grid>
  );
};

export default ExtendedEntityPagination;
